import { toError } from './parsers/error';
import { mapPhotosetItemsList, mapPhotostreamItemsList } from './parsers/items';
export function initItems(settings, http) {
  function list(folderId, options) {
    options = options || {};
    options.paging = options.paging || {};
    const baseRequestOptions = {
      per_page: options.paging.size || settings.itemsLimit,
      page: options.paging.cursor || null
    };
    return folderId ? http.get(`${settings.apiUrl}${settings.apiPath}/photoset`, {
      ...baseRequestOptions,
      set_id: folderId
    }, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(mapPhotosetItemsList).catch(toError) : http.get(`${settings.apiUrl}${settings.apiPath}/photostream`, baseRequestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(mapPhotostreamItemsList).catch(toError);
  }
  return {
    list
  };
}